import React from 'react';
import { Link } from 'react-router-dom';

const CheckoutCancelPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-surface-bg flex flex-col justify-center items-center text-center py-12 sm:px-6 lg:px-8">
      <h2 className="font-display tracking-tight text-2xl font-bold text-text-primary">Payment Canceled</h2>
      <p className="mt-2 text-lg text-text-body">
        Your payment process was canceled. You can try again anytime.
      </p>
      <Link
        to="/dashboard"
        className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-accent-blue hover:bg-accent-blue-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-blue"
      >
        Go to Dashboard
      </Link>
    </div>
  );
};

export default CheckoutCancelPage;

export {};
